/* Open the delivery FAQ and selected country when reached from a product. */
(() => {
  const initRates = () => {
    document.querySelectorAll('.dg-shipping-rates').forEach(root => {
      const select = root.querySelector('.dg-shipping-country-select');
      if (!select || select.dataset.ready) return;
      select.dataset.ready = 'true';
      const countries = [...root.querySelectorAll('.dg-shipping-country')];
      const options = [...select.options].filter(option => option.value);
      options.sort((a, b) => a.text.localeCompare(b.text, document.documentElement.lang));
      options.forEach(option => select.append(option));
      const selected = root.dataset.currentCountry;
      if (options.some(option => option.value === selected)) select.value = selected;
      const update = () => {
        countries.forEach(country => {
          country.hidden = Boolean(select.value) && country.dataset.country !== select.value;
          if (select.value && !country.hidden) country.open = true;
          if (!select.value) country.open = false;
        });
      };
      select.hidden = false;
      const control = select.closest('[data-shipping-country-control]');
      if (control) control.hidden = false;
      update();
      select.addEventListener('change', update);
    });
  };
  const openShipping = () => {
    initRates();
    if (window.location.hash !== '#livraison-frais-de-port') return;
    const details = document.getElementById('livraison-frais-de-port');
    if (!details) return;
    details.open = true;
    const panel = details.querySelector('.disclosure__panel');
    if (panel) panel.style.height = 'auto';
    const summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(() => details.scrollIntoView({ block: 'start' }));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openShipping, { once: true });
  else openShipping();
  window.addEventListener('hashchange', openShipping);
})();
